import { render } from "./FileDemo.vue?vue&type=template&id=6c9f3d1c"
import script from "./FileDemo.vue?vue&type=script&lang=js"
export * from "./FileDemo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__